export const ApiFiles = {
    upload: data => ({
        url: '/upload',
        method: 'POST',
        data
    })
};